<template>
  <div
    style="display: flex; flex-direction: row; align-items: stretch"
    class="center"
    :title="$t('common.title_manageColumnsName')"
  >
    <template v-if="showTool">
      <div class="inside_input_icons">
        <v-btn
          :title="$t('common.ok')"
          icon
          large
          @click="parentUpdateDynamicFieldItem(dynamicField, currentData)"
        >
          <v-icon color="primary" dark>check_circle</v-icon>
        </v-btn>
        <v-btn :title="$t('common.cancel')" icon large @click="changeBackData">
          <v-icon color="pink">cancel</v-icon>
        </v-btn>
        <!-- <b-icon
          class="draggable_icon hover clickable"
          icon="check-circle"
          variant="success"
          @click="parentUpdateDynamicFieldItem(dynamicField, currentData)"
        ></b-icon>
        <b-icon
          class="draggable_icon hover clickable"
          icon="x-circle"
          variant="danger"
          @click="changeBackData"
        ></b-icon> -->
      </div>
    </template>

    <v-text-field
      solo
      text-center
      hide-details="auto"
      :value="currentData"
      :state="valid_column_state"
      :rules="[rules.required, ruleColumnExist, ruleXmlStandard]"
      @keyup="updateTempData($event)"
    >
    </v-text-field>

    <!-- <b-form-input
      @mouseover="$event.target.focus()"
      class="draggable_input"
      style="display: inline"
      :value="currentData"
      @keyup="updateTempData($event)"
      :state="valid_column_state"
      required
    ></b-form-input> -->
  </div>
</template>


<script>
export default {
  props: [
    "dynamicField",
    "updateDynamicFieldItem",
    "isExistingDynamicField",
    "rules",
    "isPopped",
    "existedColumnList",
    "invalidNameList",
  ],

  mounted() {
    this.previousData = this.currentData = this.dynamicField.label;
    this.checkColumnName();
  },

  data() {
    return {
      currentData: "",
      previousData: "",
      columnNameError: "",

      existedColumn: false,
      existedName: "",
      invalidName: false,
    };
  },

  computed: {
    showTool() {
      return this.valid_column_state ? true : false;
    },

    ruleColumnExist() {
      if (this.valid_column_state == null) return true;
      return !this.existedColumn || this.$t("common.tableColumnDuplicated") + ` [${this.existedName}]`;
    },

    ruleXmlStandard() {
      if (this.valid_column_state == null) return true;
      return !this.invalidName || this.$t("common.tableColumnXmlStandard");
    },

    valid_column_state() {
      if (this.currentData == this.previousData) {
        return null;
      } else if (this.currentData == null || this.currentData == "") {
        return false;
      } else if (this.isExistingDynamicField(this.currentData, false)) {
        return false;
      } else {
        return true;
      }
    },
  },

  watch: {
    /** @param {bool} v */
    isPopped(v) {
      if (!v) return;
      this.previousData = this.currentData = this.dynamicField.label;
      this.checkColumnName();
    },
    existedColumnList() {
      if (this.existedColumn) this.checkColumnName();
    }
  },

  methods: {
    checkColumnName() {
      this.existedColumn = this.existedColumnList.some((e) => {
        const ret = e.field == this.currentData;
        if (ret) this.existedName = e.field.toUpperCase();
        return ret;
      });
      this.invalidName = this.invalidNameList.some((e) => e.field == this.currentData);

      if (this.existedColumn || this.invalidName) this.previousData = "";
    },

    updateDynamicFieldSuccess() {
      this.previousData = this.currentData;
    },

    parentUpdateDynamicFieldItem(dynamicField, currentData) {
      if (this.updateDynamicFieldItem(dynamicField, currentData)) {
        this.previousData = this.currentData;
        this.$emit('updateInput');
      }
    },

    updateTempData(event) {
      // console.log(event.target.value)
      this.existedColumn = false;
      this.invalidName = false;
      this.existedName = "";

      this.existedColumn = this.isExistingDynamicField(event.target.value, false);
      if (this.existedColumn) this.existedName = event.target.value.toUpperCase();
      this.currentData = event.target.value;
    },

    changeBackData() {
      this.currentData = this.previousData;
    },
  },
};
</script>